import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo } from 'react';
import { Button, HStack } from '@chakra-ui/react';
import { IconButton } from '../../../../buttons';
const CatalystItemFC = ({ catalyst, isReadonly, onSelect, onDelete }) => {
    return (_jsxs(HStack, { gap: "4px", w: "100%", children: [_jsx(Button, { variant: "ghost", pointerEvents: isReadonly ? 'none' : 'auto', p: "4px", justifyContent: "left", size: "smSquare", width: "100%", onClick: onSelect, children: catalyst.name }), !isReadonly && _jsx(IconButton, { isDisabled: isReadonly, onClick: onDelete, icon: "Cross" })] }));
};
export const CatalystItem = memo(CatalystItemFC);
//# sourceMappingURL=CatalystItem.js.map